
<div class="wrapperDiv">
  <div class="col-md-6 col-10 login-form">
    <form name="form" (ngSubmit)="f.form.valid && resetPassword()" #f="ngForm" >
    <h2 class="text-center">Réinitialiser le mot de passe</h2>
    <div class="form-group titre">
      <input type="email" class="form-control"
      [ngClass]="{ 'forminput-invalid':f.submitted &&
      (!model.login ||model.login?.length == 0 )}" [(ngModel)]="model.login" #email="ngModel" name="login" placeholder="Identifiant" required>
    <div *ngIf="f.submitted  && !model.login" class="text-danger">champ Obligatoire</div>
  </div>
  <div class="text-center">
    <div class="text-center titre"></div>
            <button  type="submit" class="btn btn-indigo login-btn">Valider</button>
            <br/>
            <button type="button" class="btn login-btn btn-secondary"[routerLink]="['/login']">Annuler</button>
  </div>
        <!-- </div> -->

    </form>
  </div>
</div>
